import { render } from "./QuanTri.vue?vue&type=template&id=58e1c080"
import script from "./QuanTri.vue?vue&type=script&lang=js"
export * from "./QuanTri.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__